import * as types from '../actions/types';


export default function productReducer(state = {
  details: null,
  inFlight: false,
}, action) {
  switch (action.type) {
    case types.IN_FLIGHT:
      return {
        ...state,
        inFlight: true,
      };
    case types.RECEIVE_PRODUCT_VARIATION_RESULT:
      return {
        details: action.product,
        inFlight: false,
      };
    default:
      return state;
  }
}
